
<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/SessionCutoff.png"
                                                    class="mh-45px pb-2">
                                                <div class="ml-2">
                                                    <h3 class="main-content-label mb-1"><b>
                                                            Scheduled Dates
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                        List Of Scheduled Dates
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3" [formGroup]="SessionCutOff">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Search
                                                </mat-label>
                                                <input class="color" matInput placeholder="Search"
                                                    formControlName="SearchString" (keyup)="keypress()">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-1 prpl">
                                            <button id="addBtn" type="button"
                                                class="btn btn-primary btn-icon-text  mt-1"
                                                (click)="addnewrecord()">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/plus.gif"
                                                        style="margin-right: 5px;">
                                                   New
                                                </span>
                                            </button>
                                        </div>
                                    </div> <!-- if not used then remove it so removing it  start-->
                                    <hr class="mt-2">
                                    <div class="table-responsive table-container">
                                        <table appShortTable id="datatable"
                                        class="table  table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
    
                                                    <th class="f600">
                                                        Session
                                                    </th>
                                                    <th class="f600">
                                                        College
                                                    </th>
                                                    <th class="f600">
                                                        Course
                                                    </th>
                                                    <th class="f600">
                                                        Activity
                                                    </th>
                                                    <th width="10%" class="f600 text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let cutoff of SessionCutOffList;">
                                                    <td>{{cutoff.SnName}}</td>
                                                    <td>{{cutoff.CgName}}</td>
                                                    <td>{{cutoff.CoName}}</td>
                                                    <td>{{cutoff.CdDesc}}</td>
                                                    <td class="text-center">
    
                                                        <a class="floating" title="Edit"
                                                            (click)="prepopulateRecord(cutoff)">
                                                            <i class="fa fa-edit"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event)"></mat-paginator>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>
